import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { logger } from './utils/logger';
import { initSentry } from './utils/sentry';
// Performance monitoring integrated into monitoring.ts

// P0.8: initialize error tracking before anything renders (no-op until a
// REACT_APP_SENTRY_DSN is provisioned).
void initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Mark React start for performance measurement
if ('performance' in window && performance.mark) {
  performance.mark('react-start');
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Mark React end and measure
if ('performance' in window && performance.mark && performance.measure) {
  performance.mark('react-end');
  performance.measure('react-initialization', 'react-start', 'react-end');
}

// Report Web Vitals to analytics
reportWebVitals((metric) => {
  // In production, send to analytics service
  if (process.env.NODE_ENV === 'production') {
    // Example: gtag('event', metric.name, { value: metric.value });
  } else {
    logger.log('Web Vital:', metric);
  }
});
